import httpClient from "@/plugins/axios";

export const getEvents = async (page, pageSize = 10) => {
    const response = await httpClient.get(`/v1/events/?page=${page}&page_size=${pageSize}&admin_view=1`);
    return response;
}

export const getEvent = async (id) => {
    const response = await httpClient.get(`/v1/events/${id}/?admin_view=1&translations`);
    return response;
}

export const saveEvent = async (eve) => {
    if (eve.id) {
        return await updateEvent(eve);
    }
    else {
        return await insertEvent(eve);
    }
}

const insertEvent = async (eve) => {
    const response = await httpClient.post('/v1/events/?admin_view=1&html=true', eve)
    return response;
}

const updateEvent = async (eve) => {
    const response = await httpClient.put(`/v1/events/${eve.id}/?admin_view=1&html=true`, eve)
    return response;
}

export const deleteEvent = async (id) => {
    const response = await httpClient.delete(`/v1/events/${id}/?admin_view=1`)
    return response;
}

export const getEnrollments = async (id) => {
    const response = await httpClient.get(`/v1/events/${id}/enrollments/?admin_view=1`)
    return response;
}